/* eslint-disable lumapps/no-classname-strings */
import React, { RefObject } from 'react';

import { useClassnames } from '@lumapps/classnames';
import { Menubar } from '@lumapps/lumx-menu/components/Menubar';
import { Size } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { GENERATIVE_AI_TOOLBAR_CLASSNAME } from '../../constants';
import { WREX_GENERATED_CONTENT } from '../../keys';
import { GenerativeContentButton } from '../GenerativeContentButton/GenerativeContentButton';
import { RefineContentButton } from '../RefineContentButton/RefineContentButton';

import './index.scss';

export interface GenerativeAIToolbarProps {
    className?: string;
    parentDialogRef?: RefObject<HTMLDivElement>;
    editorRef: RefObject<HTMLDivElement>;
}

export const GenerativeAIToolbar: React.FC<GenerativeAIToolbarProps> = ({ className, parentDialogRef, editorRef }) => {
    const { block } = useClassnames(GENERATIVE_AI_TOOLBAR_CLASSNAME);
    const { translateKey } = useTranslate();
    // Anchor for the refine dialog, so it aligns to the toolbar's width, not the small button's.
    const toolbarRef = React.useRef<HTMLElement>(null);

    return (
        <Menubar
            ref={toolbarRef}
            ariaLabel={translateKey(WREX_GENERATED_CONTENT.AI_EDITOR_TOOLBAR_LABEL)}
            size={Size.s}
            className={block([className])}
        >
            <RefineContentButton editorRef={editorRef} toolbarRef={toolbarRef} />

            <GenerativeContentButton parentDialogRef={parentDialogRef} />
        </Menubar>
    );
};
